import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  MailPlus,
  MessagesSquare,
  Settings,
  Calendar1Icon,
  LogOut,
} from "lucide-react";
import { Menu } from "antd";
import { useEffect, useMemo, useState } from "react";
import { clearSession } from "../utils/authSession";

export default function TeamSidebar() {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  // Only one submenu group for firms: service requests
  const rootSubmenuKeys = useMemo(() => ["sr"], []);
  const [openKeys, setOpenKeys] = useState([]);

  const handleLogout = () => {
    clearSession();
    navigate("/login");
  };

  const getSelectedKey = () => {
    if (path.includes("/team/dashboard")) return "dashboard";
    if (path.includes("/team/requests")) return "requests";
    if (path.includes("/team/chats")) return "chats";
    if (path.includes("/team/meetings")) return "meetings";
    if (path.includes("/team/teamProfile")) return "settings";
    return "";
  };

  useEffect(() => {
    const keys = [];
    if (path.includes("/team/requests")) keys.push("sr");
    setOpenKeys(keys);
  }, [path]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((k) => !openKeys.includes(k));
    if (!latestOpenKey) return setOpenKeys(keys);
    if (rootSubmenuKeys.includes(latestOpenKey)) setOpenKeys([latestOpenKey]);
    else setOpenKeys(keys);
  };

  // Firm-only: requests under Service Requests
  const srChildren = [
    { key: "requests", label: <Link to="/team/requests">Service Requests</Link> },
  ];

  // Firm-only items (no services, no firms, no content, no queries)
  const items = [
    {
      key: "dashboard",
      icon: <LayoutDashboard size={18} />,
      label: <Link to="/team/dashboard">Dashboard</Link>,
    },
    {
      key: "sr",
      icon: <MailPlus size={18} />,
      label: "Service Requests",
      children: srChildren,
    },
    {
      key: "chats",
      icon: <MessagesSquare size={18} />,
      label: <Link to="/team/chats">Chats & Messages</Link>,
    },
    {
      key: "meetings",
      icon: <Calendar1Icon size={18} />,
      label: <Link to="/team/meetings">Meetings</Link>,
    },
    {
      key: "settings",
      icon: <Settings size={18} />,
      label: <Link to="/team/teamProfile">Profile</Link>,
    },
    {
      key: 'logout',
      label: (
        <button
          type="button"
          onClick={handleLogout}
          style={{
            font: 25,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            width: '100%',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      ),
    },
  ];

  return (
    <aside className="admin-sidebar">
      <Menu
        mode="inline"
        theme="dark"
        className="sidebar-menu"
        selectedKeys={[getSelectedKey()]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        items={items}
      />
    </aside>
  );
}
